import { render } from "./TvShow.vue?vue&type=template&id=2e8344d4&scoped=true"
import script from "./TvShow.vue?vue&type=script&lang=js"
export * from "./TvShow.vue?vue&type=script&lang=js"

import "./TvShow.vue?vue&type=style&index=0&id=2e8344d4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8344d4"]])

export default __exports__